import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import BrandLogo from '@/components/BrandLogo';

/**
 * Ghost toolbar button: full label from `sm` up, compact `shortLabel` on narrow screens.
 */
export function ToolbarCaptionButton({
  icon: Icon = ArrowLeft,
  label,
  shortLabel,
  className = '',
  ...props
}) {
  return (
    <Button
      type="button"
      variant="ghost"
      className={`text-[#2D2A26] hover:text-[#C05621] shrink-0 ${className}`.trim()}
      {...props}
    >
      <Icon className="h-4 w-4 shrink-0 sm:mr-2" aria-hidden />
      <span className="hidden sm:inline">{label}</span>
      <span className="sm:hidden">{shortLabel ?? label}</span>
    </Button>
  );
}

/**
 * Sticky top bar shared across inner pages. Brand lockup is clickable
 * (navigates home). Uses shrink-0 so "Katha Mithra" never truncates.
 */
export default function PageHeader({ children, 'data-testid': dataTestId = 'page-header' }) {
  const navigate = useNavigate();
  return (
    <nav
      className="bg-[#FDFBF7]/80 backdrop-blur-md border-b border-[#E6E2D6] sticky top-0 z-50"
      data-testid={dataTestId}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
        <div className="flex justify-between items-center gap-2 sm:gap-4 min-w-0">
          <button
            type="button"
            onClick={() => navigate('/')}
            className="flex items-center gap-2 sm:gap-3 shrink-0 hover:opacity-80 transition-opacity"
            aria-label="Go to home"
          >
            <BrandLogo className="h-8 w-8 sm:h-10 sm:w-10" />
            <div className="text-left">
              <span className="block text-lg sm:text-2xl font-serif font-semibold text-[#2D2A26] leading-tight whitespace-nowrap">
                Katha Mithra
              </span>
              <span className="block text-[10px] sm:text-xs text-[#6B665E]">कथा मित्र</span>
            </div>
          </button>
          <div className="flex flex-wrap items-center justify-end gap-2 shrink-0">{children}</div>
        </div>
      </div>
    </nav>
  );
}
